import './Image360.css';
import React from 'react';
import Helmet from 'react-helmet';
import { tealiumClickFunc, tealiumMergeClickData } from "../../../utils/tealium";
var Image360 = function Image360(_ref) {
  var imageSrc = _ref.imageSrc,
    _ref$analytics = _ref.analytics,
    analytics = _ref$analytics === void 0 ? {} : _ref$analytics;
  var params = analytics.params,
    bannerClickAnalytics = analytics.bannerClickAnalytics,
    name = analytics.name;
  var currentZoom = 0;
  var isSendZoomAnalytics = true;
  var sendAnalytics = function sendAnalytics() {
    bannerClickAnalytics && tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), name);
  };
  var getCurrentZoom = function getCurrentZoom(updatedZoom) {
    var roundedNmb = Math.floor(updatedZoom);
    isSendZoomAnalytics = currentZoom !== roundedNmb;
    currentZoom = roundedNmb;
  };
  var zoomWheelHandler = function zoomWheelHandler() {
    if (isSendZoomAnalytics) {
      sendAnalytics();
    }
  };
  var imageViewer = /*#__PURE__*/React.createRef();
  React.useEffect(function () {
    var viewer;
    var id = setInterval(function () {
      if (typeof pannellum !== 'undefined') {
        viewer = pannellum.viewer(imageViewer.current, {
          type: 'equirectangular',
          panorama: imageSrc,
          autoLoad: true,
          compass: true,
          showControls: false
        });
        viewer.on('zoomchange', getCurrentZoom);
        viewer.on('touchstart', sendAnalytics);
        viewer.on('mousedown', sendAnalytics);
        clearInterval(id);
      }
    }, 200);
    return function () {
      viewer && viewer.off('zoomchange', getCurrentZoom);
      viewer && viewer.off('touchstart', sendAnalytics);
      viewer && viewer.off('mousedown', sendAnalytics);
      clearInterval(id);
    };
  });
  if (!imageSrc) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } else {
    var renderImage = function renderImage() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        rel: "stylesheet",
        href: "".concat(process.env.PUBLIC_URL, "/assets/styles/pannellum.css")
      }), /*#__PURE__*/React.createElement("script", {
        type: "text/javascript",
        defer: true,
        src: "".concat(process.env.PUBLIC_URL, "/assets/scripts/pannellum.js")
      })), /*#__PURE__*/React.createElement("div", {
        ref: imageViewer,
        className: "pnlm-wrapper",
        onWheel: zoomWheelHandler
      }));
    };
    return /*#__PURE__*/React.createElement(StyledContainer, null, renderImage());
  }
};
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "image-360 ".concat(commonStyles)
  }, children);
};
var commonStyles = "c1hg8phd";
export default Image360;